import React from "react";
import '../css/Menu-Specials.css';

export default function Events() {

    return (
        <div className="menu-specials-container">
            <div className="menu-specials-content-container">
                <h2></h2>
            </div>
            <ul style={{fontSize: 'x-large'}}>
                <li>Birthdays</li>
                <li>Bridal Showers</li>
                <li>Fellowship</li>
                <li>Worship Nights</li>
                <li>Graduation Parties</li>
            </ul>
        </div>
    )
}